import Home from './components/Home.vue'
import Menu from './components/Menu.vue'
import Ubicacion from './components/Ubicacion.vue'
//import Reservas from './components/Reservas.vue'
import Pedidos from './components/Pedidos.vue'
import Hualpen from './components/Hualpen.vue'
import Chiguayante from './components/Chiguayante.vue'
import NotFound from './components/NotFound.vue'

const routes = [
  { 
    path: '/',
    component: Home
  },
  {
    path: '/menu',
    component: Menu
  },
  {
    path: '/ubicacion',
    component: Ubicacion
  },
  {
    path: '/pedidos',
    component: Pedidos
  },
  {
    path: '/hualpen',
    component: Hualpen
  },
  {
    path: '/chiguayante',
    component: Chiguayante
  },
  {
    path: '/notfound',
    component: NotFound
  },
  {
    path: '*',
    redirect: '/notfound'
  }
]


export default routes